import { getLang, localesMessages } from '@rfc/rfc-components-library/locales'
import type { LangLocales } from '@rfc/rfc-components-library/types'
import { createI18n } from 'vue-i18n'
import { adminEn } from './en/adminEn'
import { commonEn } from './en/commonEn'
import { customersEn } from './en/customersEn'
import { menuEn } from './en/menuEn'
import { ordersEn } from './en/ordersEn'
import { productionLineEn } from './en/productionLineEn'
import { productsEn } from './en/productsEn'
import { templatesEn } from './en/templatesEn'
import { adminFr } from './fr/adminFr'
import { commonFr } from './fr/commonFr'
import { customersFr } from './fr/customersFr'
import { menuFr } from './fr/menuFr'
import { ordersFr } from './fr/ordersFr'
import { productionLineFr } from './fr/productionLineFr'
import { productsFr } from './fr/productsFr'
import { templatesFr } from './fr/templatesFr'

export type AvailableLangs<T = string> = Record<string, T>
export const defaultAvailableLangs: AvailableLangs<undefined> = {
    fr: undefined,
    en: undefined
}

export type TagProducerLangLocales = LangLocales & {
    admin: typeof adminEn
    customers: typeof customersEn
    orders: typeof ordersEn
    products: typeof productsEn
    productionLine: typeof productionLineEn
    templates: typeof templatesEn
}

export type AvailableLangsType = AvailableLangs<TagProducerLangLocales>

export const capitalizedAvailableLangs = Object.keys(defaultAvailableLangs).map(
    item => item.charAt(0).toUpperCase() + item.slice(1)
)

const messages: AvailableLangsType = {
    en: {
        ...localesMessages.en,
        common: commonEn,
        admin: adminEn,
        menu: menuEn,
        customers: customersEn,
        orders: ordersEn,
        products: productsEn,
        productionLine: productionLineEn,
        templates: templatesEn
    },
    fr: {
        ...localesMessages.fr,
        common: commonFr,
        admin: adminFr,
        menu: menuFr,
        customers: customersFr,
        orders: ordersFr,
        products: productsFr,
        productionLine: productionLineFr,
        templates: templatesFr
    }
}

export const i18n = createI18n({
    allowComposition: true,
    legacy: false,
    locale: getLang() ?? 'en',
    fallbackLocale: 'en',
    globalInjection: true,
    messages
})

export default i18n
